import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { base64Map } from "./base64Map.js";
/**
 * @private
 * @description Encodes a semVer-like version string for OS
 * @param {string} semVer Input is x.y
 * @return {string} A string built from 2 characters of the base64 table that encode the semVer
 */
export function encodeOSVersion(semVer) {
  var _semVer$split = semVer.split('.'),
    _semVer$split2 = _slicedToArray(_semVer$split, 2),
    major = _semVer$split2[0],
    minor = _semVer$split2[1];
  //convert to binary
  var binaryMajorVersion = parseInt(major).toString(2);
  var binaryMinorVersion = parseInt(minor).toString(2);
  //pad to 6
  var paddedMajor = binaryMajorVersion.padStart(6, '0');
  var paddedMinor = binaryMinorVersion.padStart(6, '0');
  return base64Map[paddedMajor] + base64Map[paddedMinor];
}